import { ofType, type ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import {
  CreateReportFailure,
  CreateReportSuccess,
  LoadReportFailure,
  LoadReportsRequest,
  LoadReportsSuccess,
  ReportsActionTypes,
  type RequestReport,
  type RequestReportApplicationStatistics
} from './report.actions';
import { getPropertyReports, requestReport } from './report.service';

export const handleLoadReports = (action$: ActionsObservable<ReturnType<typeof LoadReportsRequest>>) =>
  action$.pipe(
    ofType(ReportsActionTypes.LOAD_REPORTS_REQUEST),
    map(action => action.payload),
    concatMap(payload =>
      getPropertyReports(payload.propertyId, payload.cursor).pipe(
        concatMap(reportPayload => {
          if (reportPayload.cursor) {
            return of(LoadReportsSuccess(reportPayload.content), LoadReportsRequest(payload.propertyId, reportPayload.cursor));
          }
          return of(LoadReportsSuccess(reportPayload.content));
        }),
        catchError((error: string) => of(LoadReportFailure(error)))
      )
    )
  );

export const handleRequestReport = (
  action$: ActionsObservable<ReturnType<typeof RequestReport | typeof RequestReportApplicationStatistics>>
) =>
  action$.pipe(
    ofType(ReportsActionTypes.CREATE_REPORT_REQUEST),
    map(action => action.payload),
    concatMap(requestBody =>
      requestReport(requestBody).pipe(
        map(response => CreateReportSuccess(response.data)),
        catchError((error: string) => of(CreateReportFailure(error)))
      )
    )
  );
